<p-dialog [(visible)]="visible" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw' }" [closable]="false" [modal]="true">
	<ng-template pTemplate="header">
		<div class="h2">
			{{ venueService.ooVenue.orderTypeSelectionText || "Select your order preference:" }}
		</div>
	</ng-template>
	<div class="d-flex flex-column w-100">
		<div class="p-fluid mb-3 text-center">
			<div class="h3">How do you want it?</div>
			<p-selectButton
				[options]="orderTypes"
				optionDisabled="inactive"
				optionLabel="displayName"
				(onChange)="userOrderTypeSelect($event)"
				name="orderType"
				styleClass="w-100"
				[(ngModel)]="orderTypeSelected"
				[style]="{ 'flex-direction': 'column' }"
			>
			</p-selectButton>
		</div>

		<div class="p-fluid mb-3 text-center">
			<div class="h3">{{ venueService.ooVenue.orderTimeSelectionText || "When do you want it?" }}</div>
			<p-selectButton
				[options]="timeOptions"
				optionValue="value"
				optionLabel="label"
				optionDisabled="inactive"
				(onChange)="userTimeSelect($event)"
				[(ngModel)]="timeOptionSelected"
				[style]="{ 'flex-direction': 'column' }"
			></p-selectButton>
			<div *ngIf="timeOptionSelected === 2" class="p-fluid mt-2 mb-2 text-center">
				<p-calendar
					*ngIf="futureOrderMode === 2"
					[(ngModel)]="futureOrderDate"
					[showIcon]="true"
					[minDate]="today"
					inputStyleClass="text-center"
					[maxDate]="maxFutureSelectDate"
					styleClass="w-100"
					appendTo="body"
					[touchUI]="isMobile"
					styleClass="mt-1"
					(onSelect)="selectFutureOrderDate(futureOrderDate)"
					(onInput)="selectFutureOrderDate(futureOrderDate)"
				></p-calendar>
				<p-dropdown
					name="futureOrderTime"
					[(ngModel)]="futureOrderTime"
					(onChange)="userFutureOrderTimeSelect()"
					[options]="futureOrderTimeOptions"
					[autoDisplayFirst]="false"
					placeholder="Select Time"
					appendTo="body"
					required
				></p-dropdown>
			</div>
		</div>
	</div>
	<p-button
		pRipple
		styleClass="p-button-raised p-button-success w-100 justify-content-center"
		[disabled]="timeOptionSelected === 2 && !futureOrderDate && !futureOrderTime"
		(click)="userConfirmation()"
	>
		<ng-template pTemplate="content">
			<div class="d-flex flex-column">
				<div class="text-uppercase">confirm</div>

				<div *ngIf="timeOptionSelected === 2" class="text-lowercase">
					ready on {{ moment(orderDueDateTime).format("l") }} around {{ moment(orderDueDateTime).format("LT") }}
				</div>
				<div *ngIf="timeOptionSelected === 1" class="text-lowercase">ready at {{ moment(orderDueDateTime).format("LT") }}</div>
			</div>
		</ng-template>
	</p-button>
</p-dialog>
